var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoringIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4.569 57 C 2.046 57 0 57 0 57 L 0 0 C 0 0 2.046 0 4.569 0 L 52.431 0 C 54.954 0 57 0 57 0 L 57 57 C 57 57 54.954 57 52.431 57 Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.203 23.951 C 12.203 21.744 13.992 19.955 16.199 19.955 C 18.405 19.955 20.194 21.744 20.194 23.951 C 20.194 26.157 18.405 27.946 16.199 27.946 C 13.992 27.946 12.203 26.157 12.203 23.951 Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 27.164 23.951 C 27.164 21.744 28.953 19.955 31.159 19.955 C 33.366 19.955 35.155 21.744 35.155 23.951 C 35.155 26.157 33.366 27.946 31.159 27.946 C 28.953 27.946 27.164 26.157 27.164 23.951 Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.881 37.347 C 32.559 40.755 42.135 35.449 44.966 32.369",
    fill: "transparent",
    strokeWidth: 2.0448749999999998,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoringIcon);
export default __webpack_public_path__ + "static/media/boring-icon.16f313066466d2c9fa269c3b96462d23.svg";
export { ForwardRef as ReactComponent };